/**
 * @file schemas/document-library.ts
 * @description 文件資料庫（序180/181）Zod schemas。
 *
 * 設計：不新開資料表，直接複用既有 `files` 表（`scope='document-library'`）——
 * `ownerType` 借用作分類（manual / official-notice / regulation / audit-report-archive），
 * `meta` jsonb 承載分類專屬欄位（公文的 scheme、說明文字、管理手冊是否公開）。
 * 「表單模板管理」「有機/產銷履歷資材資料庫」是既有獨立模組，不在此重複建模，
 * 前端頁面以連結卡片導向既有頁面。
 */
import { z } from 'zod';
/** 文件資料庫分類（對應 files.ownerType） */
export const DOCUMENT_LIBRARY_CATEGORIES = [
    'manual',
    'official-notice',
    'regulation',
    'audit-report-archive',
];
export const DOCUMENT_LIBRARY_CATEGORY_LABELS = {
    manual: '管理手冊',
    'official-notice': '公文',
    regulation: '法規/標準',
    'audit-report-archive': '稽核報告彙整',
};
/** 公文專屬：TOP/TAP 分類（其餘類別此欄位留空） */
export const DOCUMENT_LIBRARY_SCHEMES = ['TOP', 'TAP'];
/** 掛載一筆已上傳文件到文件資料庫（上傳本身走既有 /api/files/presign+confirm，本 schema 只在前端組 meta 用） */
export const documentLibraryMetaSchema = z.object({
    scheme: z.enum(DOCUMENT_LIBRARY_SCHEMES).optional(),
    description: z.string().max(500).optional(),
    isPublic: z.boolean().optional(),
});
/** 列表 query 參數 */
export const documentLibraryQuerySchema = z.object({
    page: z.coerce.number().int().min(1).default(1),
    pageSize: z.coerce.number().int().min(1).max(200).default(50),
    category: z.enum(DOCUMENT_LIBRARY_CATEGORIES),
    scheme: z.enum(DOCUMENT_LIBRARY_SCHEMES).optional(),
});
/** 出參 DTO（直接對應 files 表關鍵欄位 + 展開的 meta） */
export const documentLibraryItemSchema = z.object({
    id: z.number().int().positive(),
    category: z.enum(DOCUMENT_LIBRARY_CATEGORIES),
    filename: z.string(),
    sizeBytes: z.number().int(),
    mimeType: z.string(),
    scheme: z.enum(DOCUMENT_LIBRARY_SCHEMES).nullable(),
    description: z.string().nullable(),
    isPublic: z.boolean(),
    uploadedBy: z.number().int().nullable(),
    createdAt: z.string(),
});
